import { render } from "./StudyStatusMaster.vue?vue&type=template&id=bf3bff6e&scoped=true"
import script from "./StudyStatusMaster.js?vue&type=script&lang=js"
export * from "./StudyStatusMaster.js?vue&type=script&lang=js"

import "./StudyStatusMaster.vue?vue&type=style&index=0&id=bf3bff6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3bff6e"]])

export default __exports__